module.exports = __webpack_public_path__ + "img/12.3d8555cf.png";